import { ClassNamesFromIStyles, Dropdown, useClassNames } from '@h2oai/ui-kit';
import { ChartData } from 'chart.js';
import { useState } from 'react';

import { lineChartOptions } from '../../../common/utils';
import DataTable from '../../DataTable/DataTable';
import LineChart from '../../LineChart/LineChart';
import { h2ogpteColumns } from '../H2OGPTe.columns';
import { getGPTeActionsDropdownOptions, getGPTeResourceDropdownOptions, H2OGPTeColumns } from '../H2OGPTe.utils';
import { useGpteEventCounts, useGPTeEvents } from './GPTeOverallData.services';
import { dropdownStyles, gpteOverallDataStylesDefault, IGPTeOverallDataStyles } from './GPTeOverallData.styles';

interface IGPTeOverallDataProps {
  startDate: Date;
  endDate: Date;
}

const GPTeOverallData = ({ startDate, endDate }: IGPTeOverallDataProps) => {
  const [selectedResource, setSelectedResource] = useState<string | null>(null);
  const [selectedAction, setSelectedAction] = useState<string | null>(null);

  const { gpteEvents, eventsLoading, eventsError } = useGPTeEvents(
    startDate,
    endDate,
    selectedResource || undefined,
    selectedAction || undefined
  );

  const { gpteEventCountsChartData, eventCountsLoading, eventCountsError } = useGpteEventCounts(startDate, endDate);

  const classNames = useClassNames<IGPTeOverallDataStyles, ClassNamesFromIStyles<IGPTeOverallDataStyles>>(
    'gpte-overall-data',
    gpteOverallDataStylesDefault
  );

  return (
    <div className={classNames.root}>
      <div className={classNames.lineChartWrapper}>
        <LineChart
          data={gpteEventCountsChartData as ChartData<'line'>}
          options={lineChartOptions(
            '',
            gpteEventCountsChartData && gpteEventCountsChartData.labels?.length
              ? gpteEventCountsChartData.labels?.length
              : 0
          )}
          loading={eventCountsLoading}
          error={!!eventCountsError}
        />
      </div>
      <div className={classNames.tableContainer}>
        <div className={classNames.dropdowns}>
          <Dropdown
            errorMessage=""
            label="Pick Resource"
            loadingMessage=""
            onChange={(_, option) => {
              if (!option) return;
              setSelectedResource(option.key as string);
              setSelectedAction(null);
            }}
            selectedKey={selectedResource || 'all'}
            options={getGPTeResourceDropdownOptions()}
            placeholder="Pick Resource"
            styles={dropdownStyles}
            disabled={eventsLoading}
          />
          <Dropdown
            errorMessage=""
            label="Pick Action"
            loadingMessage=""
            onChange={(_, option) => {
              if (!option) return;
              setSelectedAction(option.key as string);
            }}
            options={getGPTeActionsDropdownOptions(selectedResource)}
            placeholder="Pick Action"
            styles={dropdownStyles}
            selectedKey={selectedAction || 'all'}
            disabled={eventsLoading}
          />
        </div>
        <DataTable
          items={gpteEvents || []}
          columns={h2ogpteColumns}
          searchPlaceholder={'Search by Username'}
          searchFields={[H2OGPTeColumns.Username]}
          contentHeight="calc(100vh - 300px)"
          loading={eventsLoading}
          error={!!eventsError}
          groupableFields={[
            H2OGPTeColumns.Date,
            H2OGPTeColumns.Username,
            H2OGPTeColumns.Resource,
            H2OGPTeColumns.Action,
          ]}
          sortableFields={[H2OGPTeColumns.Date, H2OGPTeColumns.Username, H2OGPTeColumns.Action, H2OGPTeColumns.Count]}
        />
      </div>
    </div>
  );
};

export default GPTeOverallData;
